// src/utils/axiosConfig.ts
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_PUBLIC_BASE_URL, // Ajusta según tu configuración
    withCredentials: true, // Permite el envío de cookies
});

export default axiosInstance;
